<template>
  <el-card class="box-card">
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">
        {{ $t('setups.title') }}
      </span>
      <span class="ring-card__header-buttons">
        <small>
          <el-tooltip content="Prev page">
            <a
                style="margin-right: 10px;"
                @click="moveBack()"><i class="el-icon-arrow-left"></i> Prev</a>
          </el-tooltip>
          <small>|</small>
          <el-tooltip content="Next page">
            <a
                style="margin-left: 10px;"
                @click="moveFwd()"> Next <i class="el-icon-arrow-right"></i></a>
          </el-tooltip>
        </small>
        <small>
          <RefreshButton @click.native="nextSetups(1,10)" />
        </small>
      </span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <el-table
          :data="setups"
          class="device-setup-table"
          style="width: 100%">
        <el-table-column
            v-if="showDeviceName"
            label="Device">
          <template slot-scope="scope">
            <span class="device-name">{{ startCase(scope.row.doorbot_kind) }} - {{ scope.row.doorbot_description }}</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="status"
            label="Setup">
          <template slot-scope="scope">
            <setup-details
                :visible.sync="scope.row.visible"
                :details="scope.row" />
            <a
                @click="scope.row.visible = true">
              <span class="setup-id">{{ '#' + scope.row.id }}</span>
              <time-zone-formatter
                  :current-time="scope.row.updated_at"
                  class="setup-date" />
            </a>
          </template>
        </el-table-column>

        <el-table-column
            label="Status"
            width="200">
          <template slot-scope="scope">
            {{ scope.row.status | capitalize }}
          </template>
        </el-table-column>

        <el-table-column
            prop="client_device_connected"
            label="Ring AP Connected"
            width="240">
          <template slot-scope="scope">
            <font-awesome-icon
                :class="{'active-device__icon': scope.row.client_device_connected, 'inactive-device__icon': !scope.row.client_device_connected }"
                :icon="circleIcon" />
          </template>
        </el-table-column>

        <el-table-column
            prop="doorbot_connected"
            label="Device Connected to Wifi"
            width="240">
          <template slot-scope="scope">
            <span
                :class="{'active-device__icon': scope.row.doorbot_connected, 'inactive-device__icon': !scope.row.doorbot_connected }">
              <font-awesome-icon :icon="circleIcon" />
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { faCircle } from "@fortawesome/fontawesome-free-solid";
import SetupDetails from "./SetupDetails";
import RefreshButton from "@/containers/Customer/RefreshButton";
import { startCase } from "lodash";

import { createNamespacedHelpers as h } from "vuex";

const { mapActions } = h("db/device");
const { mapGetters: accountGetters } = h("db/account");
export default {
  name: "DeviceSetups",
  components: {
    SetupDetails,
    RefreshButton,
  },
  props: {
    showDeviceName: {
      type: Boolean,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      disableFwd: false,
      error: {
        value: false,
        message: "Failed to load setup history",
      },
      data: { setups: [], meta: { total: 0 } },
      currentPage: 1,
    };
  },
  computed: {
    ...accountGetters(["piiAuthorized"]),
    pageSize() {
      return 10;
    },
    circleIcon() {
      return faCircle;
    },
    setups() {
      return this.data.setups;
    },
    total() {
      return this.data.meta.total;
    },
    found() {
      return this.data.setups.length > 0;
    },
  },
  watch: {
    [`entity.id`](new_id, old_id) {
      if (new_id && new_id !== new_id) {
        this.nextSetups();
      }
    },
  },
  created() {
    this.nextSetups(this.currentPage, this.pageSize, this.addToTotal);
  },
  methods: {
    startCase: startCase,
    ...mapActions(["fetchSetups"]),
    moveBack() {
      if (this.currentPage === 1) return;
      this.currentPage -= 1;
      this.nextSetups(this.currentPage, this.pageSize, this.removeToTotal);
    },
    moveFwd() {
      if (this.disableFwd) return;
      this.currentPage += 1;
      this.nextSetups(this.currentPage, this.pageSize, this.addToTotal);
    },
    addToTotal(currentData) {
      if (currentData.length >= 10)
        this.data.meta.total = this.currentPage * 10;
      else {
        this.data.meta.total += currentData.length;
        this.disableFwd = true;
      }
    },
    removeToTotal(currentData) {
      if (currentData.length >= 10) {
        this.data.meta.total = this.currentPage * 10;
        this.disableFwd = false;
      }
    },
    nextSetups(page = 1, pageSize = 10, cb = null) {
      this.loading = true;
      this.error.value = false;
      this.fetchSetups({
        id: this.entity.id,
        model: this.entity.model,
        page,
        pageSize,
      })
        .then((data) => {
          this.data.setups = data.map((s) => {
            s["visible"] = false;
            return s;
          });
          if (cb) cb(data);
        })
        .catch((e) => {
          this.error.value = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.device-setup-table {
  .setup-id {
    display: block;
    color: $--color-curious-blue;
  }
  .device-name {
    color: $--color-silver;
  }
  .setup-date {
    display: block;
    color: $--color-silver;
  }
  .inactive-device__icon {
    color: transparentize($--color-silver, 0.6);
  }
  .active-device__icon {
    color: transparentize($--color-fun-green, 0.6);
  }
}
.setups-table__footer-pagination {
  margin: 40px 0 20px;
}
</style>
